export const environment = {
    production: true,
    endpointApi: 'https://api.teki.pe/api',
    iaEndpoint: 'https://ai.teki.pe/ai',
    shareMenuUrl: 'https://menu.teki.pe',
    // Base publica de la carta QR. Vacio = mismo origen que el POS, que es
    // lo correcto en los entornos donde CloudFront enruta /carta* al SSR.
    // En local los dos apps viven en puertos distintos, por eso se apunta al SSR.
    cartaBaseUrl: '',
    shareCatalogoUrl: 'https://catalogo.teki.pe',
    urlLogo: 'assets/layout/images/logo-mirage@2x.png',
    wsEndpoint: 'https://sock.teki.pe',
    wsEndpointPrint: 'https://sock.teki.pe',
    // Instalador del servicio de impresión (siempre la última versión; lo publica el CI de printer-service)
    printerInstallerUrl: 'https://tekistorage.s3.us-east-1.amazonaws.com/impresion/ServicioImpresion-Teki.exe',
    balanzaEndpoint: 'http://127.0.0.1:9292',
    reconnectInterval: 2000,
    company: 'Teki',
    whatsappSoporte: '51976967870',
    maxDateRangeMonths: 3
};
